__webpack_require__.p = "https://festatic.playgami.scopely.com/portal-catalog/v5_4_2/";